import React from 'react'
import request from 'superagent'

const _mauSorter = (a, b) => {
  if (a.attributes.year == b.attributes.year) {
    if (a.attributes.month == b.attributes.month) {
      return 0
    } else if (a.attributes.month > b.attributes.month) {
      return -1
    } else {
      return 1
    }
  } else if (a.attributes.year > b.attributes.year) {
    return -1
  } else {
    return 1
  }
}

const _monthName = (id) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  return months[id - 1]
}

export default class MAU extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      maus: [],
      isLoading: false,
      error: null,
    }
  }

  componentDidMount() {
    this.updateMAU()
  }

  updateMAU() {
    this.setState({ isLoading: true, error: null }, () => {
      const { application_id, host } = this.props
      request
        .get(`${host}/api/v2/oauth_applications/${application_id}/mau`)
        .set('X-PCO-API-Version', '2019-02-13')
        .then((response) => {
          this.setState({
            isLoading: false,
            error: null,
            maus: response.body.data.sort(_mauSorter).slice(0, 3),
          })
        })
        .catch((error) => this.setState({ isLoading: false, error }))
    })
  }

  render() {
    return (
      <div>
        <h4>Monthly Active Users</h4>
        {this._renderContent()}
        <p className="fs-xs mt-2">
          <em>
            Full history{' '}
            <a href="/docs/apps/api/versions/2019-02-13/vertices/oauth_application_mau">
              in the API
            </a>
          </em>
        </p>
      </div>
    )
  }

  _renderContent() {
    const { maus, isLoading } = this.state

    if (!isLoading && maus.length === 0) {
      return <p style={{ fontWeight: 'bold' }}>No users yet.</p>
    } else {
      return (
        <ul>
          {maus.map((mau) => {
            return (
              <li key={mau.id}>
                <span style={{ fontWeight: 'bold' }}>{`${_monthName(
                  mau.attributes.month
                )} ${mau.attributes.year}:`}</span>{' '}
                {mau.attributes.count.toLocaleString()}
              </li>
            )
          })}
        </ul>
      )
    }
  }
}
